import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatTime' })
export class FormatTimePipe implements PipeTransform {
  transform(ms: number = 0): string {
    const seconds = Math.floor((ms / 1000) % 60);
    const minutes = Math.floor((ms / (1000 * 60)) % 60);
    const hours = Math.floor(ms / (1000 * 60 * 60));

    // display as second if less than 2 minutes
    if (hours === 0 && minutes < 2) {
      return `${seconds} s`;
    }

    // display as minutes if less than 2 hours
    if (hours === 0) {
      return `${minutes} min ${seconds} s`;
    }

    return `${hours}h ${minutes}min`;
  }
}
